import { coreTranslations } from 'translations';
import featureService from '@services/feature.service';

const canViewWeatherAndEvents = permissions => permissions.canViewWeatherAndEvents()

const canManageTtKeyword = permissions =>
    permissions.canManageTtKeyword() &&
    permissions.canOrganizationAdmin() &&
    featureService.getFeature('textToKeywords');

const canViewSubscriptionMenu = permissions =>
    (canViewWeatherAndEvents(permissions) || permissions.canViewTopics() || canManageTtKeyword(permissions));

function _rootMenu() {
    return {
        i18n: coreTranslations.ng_core_subscriptions,
        linkTitle: 'Subscriptions',
        icon: 'onsolve-subscriptions-icon',
        routeTo: '/subscriptions',
        isRenderable: true,
        accessConfiguration: permissions => canViewSubscriptionMenu(permissions)
    };
}

export default _rootMenu;
